<template>
  <div class="home">
    <section
      class="main no-flex"
      style="margin-top: 13px;"
    >

      <!-- <UsersAttendance
        :user="user"
      /> -->
      <TruckHistoryListing />
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import TruckHistoryListing from '../components/calculation/TruckHistoryListing.vue'
// import UsersAttendance from '@/components/properties/UsersAttedance.vue'


export default {
  name: 'Home',
  components: {
    TruckHistoryListing,
    // UsersAttendance,
  },
  data() {
    return {
      user: '',
    }
  },
  computed: {
    ...mapGetters(['getIsLoading']),

  },
  methods: {
    materialId(id) {
      this.materialIdToShow = id
    },
    handleUser(id) {
      this.user = id;
    },
  },
}
</script>

<style scoped lang="scss">

.main{
  padding: 90px 15px 15px 110px;
}

@media screen and (max-width: 1200px){
  .main{
    padding: 90px 15px 15px 90px;
  }
}
@media screen and (max-width: 1041px) {
  .main {
    padding: 90px 0.75rem 15px 0.75rem;
  }
}
</style>
